import { render, staticRenderFns } from "./GroupDetailLive.vue?vue&type=template&id=153b157b&scoped=true"
import script from "./GroupDetailLive.vue?vue&type=script&lang=js"
export * from "./GroupDetailLive.vue?vue&type=script&lang=js"
import style0 from "./GroupDetailLive.vue?vue&type=style&index=0&id=153b157b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153b157b",
  null
  
)

export default component.exports